<template>
  <router-view />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { initHighchartsModules } from '@/utils/highcharts-init'

onMounted(async () => {
  await initHighchartsModules()
})
</script>
